import type {TaskDefinitionRequest} from 'src/api/ProactApiClient';

/** The publish a queued Action create replays once it syncs. */
export interface QueuedTransition {
  name: string;
}

export type OfflineActionCreateRequest = TaskDefinitionRequest & {
  queuedTransition?: QueuedTransition;
};

// Outbox-only field — the create endpoint must never receive it.
export const stripQueuedTransition = (
  request: OfflineActionCreateRequest
): TaskDefinitionRequest => {
  const {queuedTransition: _queuedTransition, ...rest} = request;
  return rest as TaskDefinitionRequest;
};
